import { render, staticRenderFns } from "./gl-skeleton-amount.vue?vue&type=template&id=798a939a&scoped=true"
import script from "./gl-skeleton-amount.vue?vue&type=script&lang=js"
export * from "./gl-skeleton-amount.vue?vue&type=script&lang=js"
import style0 from "./gl-skeleton-amount.vue?vue&type=style&index=0&id=798a939a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798a939a",
  null
  
)

export default component.exports